
export const Sidebar = () => `
    <!-- SIDEBAR OVERLAY -->
    <div id="sidebar-overlay" class="sidebar-overlay hidden"></div>

    <!-- APP SIDEBAR -->
    <div id="app-sidebar" class="app-sidebar">
        <div class="sidebar-header">
            <!-- User requested replacing text with arrow -->
            <span class="title" style="font-size: 2rem; cursor: pointer;" onclick="toggleSidebar(false)">←</span>
            <button id="close-sidebar-btn" class="close-btn">✖</button>
        </div>
        <div class="sidebar-content">
            <!-- FUN FACT SECTION -->
            <div id="sidebar-fun-fact" class="sidebar-section fun-fact-box">
                <span class="fact-icon">💡</span>
                <p id="fun-fact-text">Bunları biliyor muydunuz?</p>
            </div>

            <div class="sidebar-menu">
                <button id="nav-home-btn" class="sidebar-nav-btn" aria-label="Ana Sayfaya Git">
                    <span class="icon" aria-hidden="true">🏠</span> ANA SAYFA
                </button>
                <button id="nav-about-btn" class="sidebar-nav-btn" aria-label="Hakkımızda Bilgisi">
                    <span class="icon" aria-hidden="true">ℹ️</span> HAKKIMIZDA
                </button>
                <button id="nav-contact-btn" class="sidebar-nav-btn" aria-label="İletişim Bilgileri">
                    <span class="icon" aria-hidden="true">📧</span> İLETİŞİM
                </button>
                <button id="nav-faq-btn" class="sidebar-nav-btn" aria-label="Sıkça Sorulan Sorular">
                    <span class="icon" aria-hidden="true">❓</span> S.S.S.
                </button>
                <!-- Moved Settings Here -->
                <button id="nav-settings-btn" class="sidebar-nav-btn" aria-label="Ayarları Aç">
                    <span class="icon" aria-hidden="true">⚙️</span> AYARLAR
                </button>
            </div>

            <div class="sidebar-footer">
                <div class="social-links">
                    <a href="https://www.youtube.com/@gaddaraiileprojeler" target="_blank" id="youtube-link-sidebar"
                        class="social-btn youtube">
                        <span class="icon">▶</span>
                    </a>
                    <!-- Add more socials here later -->
                </div>
                <span class="faded">© 2026 GADDAR</span>
            </div>
        </div>
    </div>
`;
